import React from "react";
import { Link } from "react-router-dom";
import DeleteOutlineIcon from "@mui/icons-material/DeleteOutline";
import EditOutlinedIcon from "@mui/icons-material/EditOutlined";

export default function DetailPageActions({
  editPath,
  onEdit,
  onRemove,
  footerStart,
}) {
  const hasActions = onRemove || editPath || onEdit || footerStart;
  if (!hasActions) return null;

  const footerClassName = [
    "detail-footer-actions",
    footerStart ? "detail-footer-actions--split" : "",
  ]
    .filter(Boolean)
    .join(" ");

  return (
    <footer className={footerClassName}>
      {footerStart && <div className="detail-footer-start">{footerStart}</div>}
      <div className="detail-footer-end">
        {onRemove && (
          <button
            type="button"
            className="detail-btn detail-btn-remove"
            onClick={onRemove}
          >
            <DeleteOutlineIcon fontSize="small" />
            Remove
          </button>
        )}
        {onEdit && (
          <button
            type="button"
            className="detail-btn detail-btn-edit"
            onClick={onEdit}
          >
            <EditOutlinedIcon fontSize="small" />
            Edit
          </button>
        )}
        {editPath && (
          <Link to={editPath} className="detail-btn detail-btn-edit">
            <EditOutlinedIcon fontSize="small" />
            Edit
          </Link>
        )}
      </div>
    </footer>
  );
}
